import { PrintColumn } from './print-modal.component';

const escapeHtml = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/** Stylesheet used only for the printed page (lives inside the hidden iframe). */
export const PRINT_CSS = `
  @page { margin: 14mm; }
  body { font-family: system-ui, Arial, sans-serif; color: #000; margin: 0; }
  h1 { font-size: 16pt; margin: 0; }
  .meta { color: #555; font-size: 9pt; margin: 2pt 0 12pt; }
  table { width: 100%; border-collapse: collapse; font-size: 9.5pt; }
  thead { display: table-header-group; }   /* repeat header on every page */
  tr { break-inside: avoid; }
  th { padding: 4pt 6pt; border-bottom: 1.5pt solid #000; }
  td { padding: 4pt 6pt; border-bottom: 0.5pt solid #999; }
`;

/** Builds the full HTML document that is sent to the printer. */
export function buildPrintDocument<T>(
  title: string,
  date: string,
  columns: PrintColumn<T>[],
  rows: T[],
  cell: (row: T, col: PrintColumn<T>) => string,
): string {
  const head = columns
    .map(c => `<th style="text-align:${c.align || 'left'}">${escapeHtml(c.header)}</th>`)
    .join('');

  const body = rows
    .map(r => '<tr>' + columns
      .map(c => `<td style="text-align:${c.align || 'left'}">${escapeHtml(cell(r, c))}</td>`)
      .join('') + '</tr>')
    .join('');

  return `<!doctype html><html><head><meta charset="utf-8">
<title>${escapeHtml(title)}</title><style>${PRINT_CSS}</style></head><body>
<h1>${escapeHtml(title)}</h1>
<p class="meta">${escapeHtml(date)} · ${rows.length} rows</p>
<table><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>
</body></html>`;
}